import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip"
import { useTerminalTheme } from "@/lib/terminal/use-terminal-theme"
import { cn } from "@/lib/utils"

const TOOLTIP_SIDE_OFFSET = 12
const TOOLTIP_COLLISION_PADDING = 12

export const DefinitionLabel = ({
  definition,
  className,
  children,
}: {
  definition?: string
  className?: string
  children: React.ReactNode
}) => {
  const { theme } = useTerminalTheme()

  if (!definition) {
    return <span className={className}>{children}</span>
  }

  return (
    <span className={className}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="hover:text-text-primary hover:decoration-border-strong inline-block cursor-default no-underline transition-[color] duration-(--duration-base) ease-(--ease-terminal) hover:underline hover:decoration-1 hover:underline-offset-[3px]">
            {children}
          </span>
        </TooltipTrigger>
        <TooltipContent
          side="right"
          align="center"
          sideOffset={TOOLTIP_SIDE_OFFSET}
          collisionPadding={TOOLTIP_COLLISION_PADDING}
          data-terminal-theme={theme}
          className={cn(
            "type-tooltip bg-popover border-border text-foreground shadow-tooltip max-w-60 rounded-sm border px-2.5 py-2",
            theme === "dark" && "dark"
          )}
        >
          {definition}
        </TooltipContent>
      </Tooltip>
    </span>
  )
}
